import $ from 'jquery';

const $toggle = $( '.js-view-toggle' );

if ( $toggle.length ) {
	$toggle.on( 'click', '.view-toggle__item', function( event ) {
		event.preventDefault();
		const $self = $( this );

		$self
			.closest( '.js-view-toggle' )
			.find( '.view-toggle__item' )
			.toggleClass( 'is-current' );
		
		if ( $('#posts').hasClass('js-block-view') ) {
			$( '#posts' ).removeClass('js-block-view').addClass( 'js-list-view' );
			$( '#posts div[class*="col-"]:not(:first-child)' ).removeClass( 'col-md-6 col-xl-4' ).addClass( 'col-12' );
			$( '#posts div[class*="col-"]:not(:first-child) .article-card' ).addClass( 'article-card--horizontal' );
		}
		else {
			$( '#posts' ).removeClass('js-list-view' ).addClass( 'js-block-view' );
			$( '#posts div[class*="col-"]:not(:first-child)').removeClass( 'col-12' ).addClass( 'col-md-6 col-xl-4' );
			$( '#posts div[class*="col-"]:not(:first-child) .article-card' ).removeClass('article-card--horizontal' );
		}
	} );
}
